import React from 'react'
import './AboutHero.css'
import timeline from "../../../../assets/images/about/timeline.png"
import timelineMobile from "../../../../assets/images/about/timeline-mobile.png"

const AboutHero = () => {
  return (
    <section className="about-hero">

      <div className="about-container">

        {/* TITLE */}
        <h2 className="about-title">
          A Legacy of Industry <span>Since 1998</span>
        </h2>

        {/* TIMELINE */}
        <div className="timeline">

         <img src={timeline} alt="" className="timeline-bg" />
          <img src={timelineMobile} alt="timeline mobile" className="timeline-bg mobile" />

        </div>

        {/* TEXT */}
        <div className="about-text">
          <p>
            <strong>Advanced Pharmaceutical Industries (API)</strong> : is a premier Iraqi pharmaceutical manufacturing entity currently undergoing a comprehensive strategic transformation.
            We are rebuilding not just a facility, but a legacy of trust, driven by the most extensive market research ever conducted on Iraq’s public and private healthcare sectors.
          </p>

          <p>
            Guided by Insight and Driven by Expertise. Our rebirth is spearheaded by a prestigious group of Iraqi market experts who possess decades of on-the-ground experience. This local leadership is fortified by strategic partnerships with global pharmaceutical leaders, ensuring that every pill, capsule, ampoule, and vial produced within our walls meets international benchmarks of efficacy and safety.
          </p>
        </div>

      </div>

    </section>
  )
}

export default AboutHero